// extracted by mini-css-extract-plugin
export default {"element":"CarouselArrow-module--element--6e1b4","left":"CarouselArrow-module--left--248e9"};